import http from "../../services/httpService";
import { injectHtml } from "../../utils/htmlUtil";
import { openDialog, dialogModel } from "../common/dialog";
import { error, isEmpty, initToggleIconRotate, rotateElement } from "../common/global";
import { catchError } from "../../utils/errorUtil";

const props = {
    //ADD TO BASKET
    addToBasketProductPage: '.add-to-basket-product-page',
    customersAlsoBought: '.add-to-basket-upsells',
    customersAlsoBoughtBasket: '.add-to-basket-upsells-basket',
    
    addToBasketListItem: '.add-to-basket-list-item',
    selectProductOptionMessage: '#select-product-option-message',

    addToBasketOutOfStock: '.add-to-basket-out-of-stock',
    addToBasketSelectOptions: '.add-to-basket-select-options',

    //BUNDLE PRODUCT PROPERTIES
    bundleComponentOption: '.bundle-component-option',
    productVariantOption: '.product-option',
    selectedOptionClass: 'selected-option',

    //BASKET INDEX VIEW
    basketIndexMarker: '#basket-main',
    quantitySelect: '.select-quantity',

    basketItemRemove: '.basket-item-remove',
    basketItemWrapper: '.basket-item-wrapper',

    //MINI-BASKET
    miniBasketMarker: 'div#mini-basket-marker',
    miniBasketWrapper: 'div#mini-basket-wrapper',
    miniBasketOpen: '#view-mini-basket',
    miniBasketClose: 'i#mini-basket-close'
};

//add to basket properties. used during an 'add to basket' lifecycle.
let addToBasketStartTime = null;
let addToBasketSuccessful = false;
let addToBasketMinimumDuration = 1000;
let addToBasketActiveButton = null;

export function initBasketEvents() {

    if ($(props.addToBasketProductPage).length) {
        addToBasketProductPage();
    }
    
    if ($(props.addToBasketListItem).length) {

        //TODO
    }

    if ($(props.addToBasketOutOfStock).length) {

        //item variant selected / product is out of stock
        //right now we won't tie an event to this button
    }

    if ($(props.addToBasketSelectOptions).length) {

        //button display says add to basket, but not enough options have been selected.
        //when clicked, display 'select options' message.

        $(props.addToBasketSelectOptions).off('click').on('click', function () {

            $(props.selectProductOptionMessage).show();
        });
    }

    if ($(props.basketIndexMarker).length) {
        initBasketPageEvents();

        basketLoadEvent();
    }

}

//START - PRODUCT PAGE ADD TO BASKET - CORE
async function addToBasketProductPage() {

    $(props.addToBasketProductPage).off('click').on('click', function () {
        //runs standard add to basket function; also runs product page specific animation / action.
        addToBasket($(this));
    });
}

//async function addToBasketFromBasketUpsells() {
//    $(props.customersAlsoBoughtBasket).off('click').on('click', function () {

//        addToBasketActiveButton = $(this);

//        if (isEmpty(addToBasketActiveButton.data('pvid'))) {

//            $(props.selectProductOptionMessage).show();
//            return;
//        }

//        //adds a single product variant to the basket
//        //this covers product pages that display a single variant AND multiple variants
//        console.log("adding");
//        var result = addSingleProductToBasket().then(location.reload());
//        console.log(result);

//        if (result.responseType === "SUCCESS") {
//            console.log("success");
//            location.reload();
//        }
//    });
//}
export async function addToBasketCustomerAlsoBought() {

    $(props.customersAlsoBought).off('click').on('click', function () {
        console.log("test");
        addToBasketActiveButton = $(this);

        //determine whether this is a single product being added or several items as part of a 'bundle'
        //product can be added to the basket in one of 2 ways; by variant (single product variant) or a product bundle (2 or more products bundled together)
        //NOTE: some products have a single variant 

        if (isEmpty(addToBasketActiveButton.data('pvid'))) {

            $(props.selectProductOptionMessage).show();
            return;
        }

        //adds a single product variant to the basket
        //this covers product pages that display a single variant AND multiple variants
        addSingleProductToBasket();
    });
}

async function addToBasket(addToBasketElement) {

    //assign the clicked button entity to a global variable for use in the add to basket helper methods
    addToBasketActiveButton = addToBasketElement;

    //determine whether this is a single product being added or several items as part of a 'bundle'
    //product can be added to the basket in one of 2 ways; by variant (single product variant) or a product bundle (2 or more products bundled together)
    //NOTE: some products have a single variant 

    if (isEmpty(addToBasketActiveButton.data('pvid'))) {

        $(props.selectProductOptionMessage).show();
        return;
    }

    const selectedLinkedProductItems = $(props.bundleComponentOption + '.' + props.selectedOptionClass);

    if (selectedLinkedProductItems.length == 0) {

        //adds a single product variant to the basket
        //this covers product pages that display a single variant AND multiple variants
        addSingleProductToBasket();

    } else {

        //adds a single product variant to the basket
        addProductBundleToBasket(selectedLinkedProductItems);
    }

    //NOTE: GA event is handled by addSingleProductToBasket or addProductBundleToBasket
}

async function addSingleProductToBasket() {

    //adds a single product variant to the basket
    addToBasketSuccessful = false;
    addToBasketStartTime = new Date();

    setTimeout(function () {

        addToBasketTimeOutCompletion();

    }, addToBasketMinimumDuration);

    toggleAddToBasketAnimation(true);

    var productVariantId = addToBasketActiveButton.data('pvid');

    //TODO: if multiple variants are available for a product then we need to check here that a pvid is set.
    //If this is not the case then an error must be flagged to the user.

    const data = {
        ProductVariantId: productVariantId
    };

    const result = await addToBasketService(data);

    if (result.responseType == "SUCCESS" || result.responseType == "SUCCESS_PARTIALFULFILMENT") {
        //Success - reload mini basket, end button animation

        addToBasketSuccessful = true;
        checkTimeoutMinimumPeriodExceeded();

        //if basket item id has been returned push a GA event
        if (!isEmpty(result.id)) {

            //push an event to GA4 for the addition to the basket

            //NOTE: override quantity value returned as we only ever add 1 to the basket
            //if this changes we need to pick up the quantity from the view and assign it here.
            //add to basket becomes 'update basket item' if the item already exists in the basket, thus returning the wrong quantity
            await addToBasketEvent(result.id, 1);
        }
    }
    else {

        addToBasketSuccessful = false;
        toggleAddToBasketAnimation(false);

        openDialog({
            ...dialogModel,
            title: 'An error occurred',
            content: result.responseMessage,
            displayConfirm: false,
            cancelButtonText: 'Close',
            theme: 'delete'
        });
    }
}

async function addProductBundleToBasket(selectedLinkedProductItems) {

    //adds multiple product variants to the basket
    //this function must always pass a primary product variant id and at least one linked item product variant id(s)
    addToBasketSuccessful = false;
    addToBasketStartTime = new Date();

    setTimeout(function () {

        addToBasketTimeOutCompletion();

    }, addToBasketMinimumDuration);

    toggleAddToBasketAnimation(true);

    //PRIMARY
    const productVariantId = addToBasketActiveButton.data('pvid');

    //build array of linked item id's
    let selectedItems = [];

    selectedLinkedProductItems.each(function (i, obj) {

        selectedItems.push($(this).data('id'));
    });

    const data = {
        ProductVariantId: productVariantId,
        SelectedLinkedProductVariants: selectedItems
    };

    const result = await addBundleToBasketService(data);

    if (result.responseType == "SUCCESS" || result.responseType == "SUCCESS_PARTIALFULFILMENT") {
        //Success - reload mini basket, end button animation

        addToBasketSuccessful = true;
        checkTimeoutMinimumPeriodExceeded();

        //if basket item id has been returned push a GA event
        if (!isEmpty(result.id)) {

            //push an event to GA4 for the addition to the basket

            //NOTE: override quantity value returned as we only ever add 1 to the basket
            //if this changes we need to pick up the quantity from the view and assign it here.
            //add to basket becomes 'update basket item' if the item already exists in the basket, thus returning the wrong quantity
            await addToBasketEvent(result.id, 1);
        }
    }
    else {

        addToBasketSuccessful = false;
        toggleAddToBasketAnimation(false);

        openDialog({
            ...dialogModel,
            title: 'An error occurred',
            content: result.responseMessage,
            displayConfirm: false,
            cancelButtonText: 'Close',
            theme: 'delete'
        });
    }
}

async function addUpsellFromBasket(eventElement) {
    addToBasketActiveButton = eventElement;
    await addSingleProductToBasket();
    location.reload();
}
async function removeBasketItem(eventElement) {

    var parentWrapper = eventElement.closest(props.basketItemWrapper);

    var basketItemId = parentWrapper.data('item-id');

    //push an event to GA4 for the removal from the basket
    //IMPORTANT NOTE: we must call the product build for the remove from basket BEFORE we call the actual remove from basket as the
    //basket item is physically deleted from the DB. Therefore, if we called this after there'd be no data to find.

    //As such we need to make sure that the await aspect of this function works properly as the call to GET basket item product data
    //must ALWAYS take place before the REMOVE command is sent
    await removeFromBasketEvent(basketItemId, null);


    //As per above, call remove function AFTER the GA event has been called.
    const data = {
        basketItemId: basketItemId
    };

    const result = await removeBasketItemService(data);

    location.reload();
}

async function editBasketItem(eventElement) {

    var parentWrapper = eventElement.closest(props.basketItemWrapper);

    var basketItemId = parentWrapper.data('item-id');

    var quantity = 0;
    
    var basketItemRowQuantitySelect = parentWrapper.find(props.quantitySelect);

    quantity = basketItemRowQuantitySelect.val();

    const data = {
        basketItemId: basketItemId,
        quantity: quantity
    };

    const result = await editBasketItemService(data);

    if (result.quantityUpdated === true) {

        if (result.quantityNew > result.quantityOriginal) {

            //quantity INCREASE
            var quantity = result.quantityNew - result.quantityOriginal;

            //console.log('Before quantity increase');

            await addToBasketEvent(basketItemId, quantity);
        }

        if (result.quantityNew < result.quantityOriginal) {

            //quantity DECREASE
            var quantity = result.quantityOriginal - result.quantityNew;

            //console.log('Before quantity decrease');

            await removeFromBasketEvent(basketItemId, quantity);
        }
    }

    location.reload();
}

//START - GA4 BASKET HELPER FUNCTIONS
async function addToBasketEvent(basketItemId, quantity) {

    var gaProduct = await getBasketItemProductDetails(basketItemId);

    if (gaProduct) {

        if (quantity !== null) {

            //override quantity if value passed
            gaProduct.productItem.quantity = quantity;
            gaProduct.itemValue = gaProduct.itemValueSingle * quantity;
        }

        var addToBasketGaCode = {
            event: "add_to_cart",
            ecommerce: {
                currency: gaProduct.currency,
                value: gaProduct.itemValue,
                items: [gaProduct.productItem]
            }
        }

        //console.log("addToBasketGaCode", addToBasketGaCode);

        window.dataLayer = window.dataLayer || [];

        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push(addToBasketGaCode);
    }
}

async function removeFromBasketEvent(basketItemId, quantity) {


    var gaProduct = await getBasketItemProductDetails(basketItemId);

    if (gaProduct) {

        if (quantity !== null) {

            //override quantity if value passed
            gaProduct.productItem.quantity = quantity;
            gaProduct.itemValue = gaProduct.itemValueSingle * quantity;
        }

        var removeFromBasketGaCode = {
            event: "remove_from_cart",
            ecommerce: {
                currency: gaProduct.currency,
                value: gaProduct.itemValue,
                items: [gaProduct.productItem]
            }
        }

        //console.log("removeFromBasketGaCode", removeFromBasketGaCode);

        window.dataLayer = window.dataLayer || [];

        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push(removeFromBasketGaCode);
    }
}

async function basketLoadEvent() {

    var gaBasket = await getBasketLoadModel();

    if (gaBasket) {

        var basketLoadGaCode = {
            event: "view_cart",
            ecommerce: {
                currency: gaBasket.currency,
                value: gaBasket.basketTotal,
                items: [gaBasket.basketItems]
            }
        }

        //console.log("basketLoadGaCode", basketLoadGaCode);

        window.dataLayer = window.dataLayer || [];

        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push(basketLoadGaCode);
    }
}
//END - GA4 BASKET HELPER FUNCTIONS

function checkTimeoutMinimumPeriodExceeded() {

    //called by the add to basket event when the server returns control to the client (and the item has been successfully added to the basket).
    //if the minimum time period has not elapsed nothing will happen; instead the client will wait for the setTimeout to expire before exceuting addToBasketSuccess.
    var elapsed = new Date() - addToBasketStartTime;

    if (elapsed > addToBasketMinimumDuration) {

        addToBasketSuccess();
    }
}

function addToBasketTimeOutCompletion() {

    //when the setTimeout ends this function is called. if the add to basket process has completed BEFORE the timeout duration then it will now be executed.
    //This is the key to managing a 'minimum animation' for the add to basket process.
    if (addToBasketSuccessful) {

        addToBasketSuccess();
    }
}

function toggleAddToBasketAnimation(active) {

    //assignment uses the 'active' button declared at the start of the add to basket process.
    var addToBasketTextSpan = addToBasketActiveButton.find('.add-to-basket-text');
    var addToBasketActivityIndicator = addToBasketActiveButton.find('.add-to-basket-activity');

    //helper method to manage the state of the two elements used for animating the 'add to basket' button.
    if (active) {

        addToBasketTextSpan.hide();
        addToBasketActivityIndicator.show();
    } else {

        addToBasketTextSpan.show();
        addToBasketActivityIndicator.hide();
    }
}

function addToBasketSuccess() {

    //called when the client receives notification that an item has been successfully added to the basket
    toggleAddToBasketAnimation(false);

    showMiniBasket();

    addToBasketActiveButton.blur();
}

//END - PRODUCT PAGE ADD TO BASKET - CORE

async function initBasketPageEvents() {

    //binds all relevant events for the basket index (main basket) view

    //ML, 12/07/2022. Ability to add more than ten items (utilising a text input disabled at Robbies request).
    //$(props.customersAlsoBoughtBasket).off('change').on('change', function () {

    //    addToBasketFromBasketUpsells($(this));
    //    //changeQuantityForBasketItem($(this));
    //});


    //QUANTITY CHANGE
    $(props.quantitySelect).off('change').on('change', function () {

        editBasketItem($(this));
        //changeQuantityForBasketItem($(this));
    });

    //EDIT
    //$(props.basketItemEdit).off('click').on('click', function () {

    //    editBasketItem($(this));
    //});

    //DELETE
    $(props.basketItemRemove).off('click').on('click', function () {
        removeBasketItem($(this));
    });

    $(props.customersAlsoBoughtBasket).off('click').on('click', function () {
        addUpsellFromBasket($(this));
    });
}

//START - MINI BASKET
async function showMiniBasket() {

    const result = await getMiniBasketService();

    await injectHtml(props.miniBasketMarker, result);

    setTimeout(function () {

        $(props.miniBasketWrapper).show(500);

        $(props.miniBasketClose).off('click').on('click', function () {

            $(props.miniBasketWrapper).hide(500);
        });

    }, 100);
}

//END - MINI BASKET EVENTS


//START - SEO SERVICE FUNCTIONS

export async function getBasketItemProductDetails(basketItemId) {

    //this function returns an object representing a single 'product' related to a given basket item
    const data = {
        basketItemId: basketItemId
    };

    const result = await getBasketItemProductDetailService(data);

    if (result.responseType == "SUCCESS") {

        return result;
    }
    else {

        return null;
    }
}

async function getBasketLoadModel() {

    //this function returns an object representing the current basket
    const result = await getBasketLoadModelService();

    if (result.responseType == "SUCCESS") {

        return result;
    }
    else {

        return null;
    }
}

//END - SEO SERVICE FUNCTIONS

async function addToBasketService(data) {

    //no TRY CATCH as handled by parent
    //returns json result of add to basket attempt
    const response = await http.post('/basket/addtobasket', data);

    return response.data;
}

async function addBundleToBasketService(data) {

    //no TRY CATCH as handled by parent
    //returns json result of add to basket attempt
    const response = await http.post('/basket/addbundletobasket', data);

    return response.data;
}

async function editBasketItemService(data) {

    //no TRY CATCH as handled by parent
    //returns json result of change of quantity attempt
    const response = await http.post('/basket/updatequantity', data);

    return response.data;
}

async function removeBasketItemService(data) {

    //no TRY CATCH as handled by parent
    //returns json result of remove from basket attempt
    const response = await http.post('/basket/removefrombasket', data);

    return response.data;
}


async function getMiniBasketService() {

    //no TRY CATCH as handled by parent
    //returns json result of remove from basket attempt
    const response = await http.get('/basket/getminibasket');

    return response.data;
}

async function getBasketItemProductDetailService(data) {

    //no TRY CATCH as handled by parent
    //returns json result of add to basket attempt
    const response = await http.post('/seo/getbasketitem', data);

    return response.data;
}

async function getBasketLoadModelService() {

    //no TRY CATCH as handled by parent
    //returns json result of remove from basket attempt
    const response = await http.get('/seo/getcurrentbasketgafourmodel');

    return response.data;
}